import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from '@mui/material';
import employeesImage from '../images/portfolio-second.jpg'; // Adjust path as necessary

const ContactPage = () => {
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    inquiryType: '',
    message: '',
  });
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');
  const [snackSeverity, setSnackSeverity] = useState('success');

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

 
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    // Gather form data
    const payload = {
      name: formValues.name,
      email: formValues.email,
      inquiryType: formValues.inquiryType,
      message: formValues.message,
    };

    const response = await fetch("https://www.xfactual.org/api/contact_form.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (result.success) {
      setSnackMessage("Your message has been sent. We will get back to you shortly.");
      setSnackSeverity("success");
      // Clear form
      setFormValues({ name: "", email: "", inquiryType: "", message: "" });
    } else {
      setSnackMessage(result.error || "An error occurred. Please try again.");
      setSnackSeverity("error");
    }
  } catch (error) {
    setSnackMessage("Network error: " + error.message);
    setSnackSeverity("error");
  }
  setSnackOpen(true);
};

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
      <img
      src="../xfactualLogo.png"
      alt="XFactual Logo"
      style={{ width: "200px", height: "auto" }}
    />
      </Typography>
      <Typography variant="body1" align="center" sx={{ mb: 3 }}>
        Whether you have questions about our products, need assistance, or simply want to share your feedback,
        please fill out the form.
      </Typography>

      <Grid container spacing={4} alignItems="flex-start">
        {/* Contact Form Column */}
        <Grid item xs={12} md={6}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <TextField
              required
              label="Your Name"
              name="name"
              value={formValues.name}
              onChange={handleChange}
            />
            <TextField
              required
              label="Your Email"
              name="email"
              type="email"
              value={formValues.email}
              onChange={handleChange}
            />
            <FormControl required>
              <InputLabel id="inquiry-type-label">Inquiry Type</InputLabel>
              <Select
                labelId="inquiry-type-label"
                label="Inquiry Type"
                name="inquiryType"
                value={formValues.inquiryType}
                onChange={handleChange}
              >
                <MenuItem value="sales">Sales Inquiry</MenuItem>
                <MenuItem value="support">Technical Support</MenuItem>
                <MenuItem value="general">General Request</MenuItem>
              </Select>
            </FormControl>
            <TextField
              required
              label="Message"
              name="message"
              multiline
              minRows={4}
              value={formValues.message}
              onChange={handleChange}
            />
            <Button type="submit" variant="contained" color="primary">
              Send Message
            </Button>
          </Box>
          <Box sx={{ mt: 2, textAlign: 'left' }}>
            <Typography variant="subtitle1" gutterBottom>
              Alternatively, you can reach us at:
            </Typography>
            <Typography variant="body2">Sales: sales@xfactual.com</Typography>
            <Typography variant="body2">General Inquiries: info@xfactual.com</Typography>
            <Typography variant="body2">Support: help@xfactual.com</Typography>
          </Box>
        </Grid>

        {/* Image Column */}
        <Grid item xs={14} md={6}>
          <Box
            component="img"
            src={employeesImage}
            alt="Employees working"
            sx={{
              width: '100%',
              borderRadius: 2,
              boxShadow: 3,
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </Grid>
      </Grid>

      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={() => setSnackOpen(false)}
      >
        <Alert onClose={() => setSnackOpen(false)} severity={snackSeverity} sx={{ width: '100%' }}>
          {snackMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ContactPage;

